import { Outlet } from "react-router-dom";
import { useApp } from "../store";
import Topbar from "./shell/Topbar";
import BottomNav from "./shell/BottomNav";
import LocationModal from "./shell/LocationModal";

export default function AppShell() {
  const { authLoading } = useApp();

  if (authLoading) return null;

  return (
    <div className="app-shell">
      <Topbar />
      <main className="with-nav">
        <Outlet />
      </main>
      <BottomNav />
      <LocationModal />
    </div>
  );
}
